<template>
    <span>
        {{ $localDate(timestamp, this.dateFormat) }}, {{ $localTime(timestamp) }}
    </span>
</template>

<script>
export default {
    props: {
        timestamp: String,
        short: Boolean,
    },

    computed: {
        dateFormat() {
            if (this.short) {
                return {
                    year: '2-digit',
                    month: '2-digit',
                    day: '2-digit',
                };
            }

            return {
                weekday: 'short',
                year: 'numeric',
                month: 'short',
                day: 'numeric',
            };
        },
    },
};
</script>
